import { Row, View } from '@woodmac-hycb/layout';
import './CustomAlertManager.css'
import { Button } from '@woodmac-hycb/button';
import { TextView } from "@woodmac-hycb/typography";
import { useState, useEffect } from 'react';

function ThemeToggle({ theme, onToggle }) {
    return (
        <div>
            <span>Theme: </span>
            <label className="toggle-switch">
                <input type="checkbox" checked={theme === "dark"} onChange={onToggle} />
                <span className="slider"></span>
            </label>
        </div>
    );
}

function Header() {

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

    useEffect(() => {
        document.body.classList.remove("light", "dark");
        document.body.classList.add(theme);
        localStorage.setItem("theme", theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
    };

    return (
        <Row gap={64} className='header header-box'>
            <TextView fontSize={50} as="h1">Custom Alert Manager</TextView>

            <Row gap={16} alignItems="center">
                <ThemeToggle theme={theme} onToggle={toggleTheme} />
                <View alignItems="center" gap={16}>
                    {/*<Button onClick={logout}>Logout</Button>*/}
                </View> </Row>
        </Row>
    );


} export default Header;